import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generador-qr',
  templateUrl: './generador-qr.component.html',
  styleUrls: ['./generador-qr.component.scss'],
})
export class GeneradorQRComponent implements OnInit {
  @Input() Codigo:string="";
  @Input() size:number=100;
  constructor() { }

  ngOnInit() {
  }

}
